<template>
  <form>
    <div class="form-group">
      <label class="mb-1" for="username">Username</label>
      <input type="text" class="form-control" id="username" v-model="username" placeholder="Enter username">
    </div>
    <div class="form-group">
      <label class="mb-1" for="email">Email</label>
      <input type="text" class="form-control" id="email" v-model="email" placeholder="Enter email">
    </div>
    <div class="form-group">
      <label class="mb-1" for="password">Password</label>
      <input type="password" class="form-control" id="password" v-model="password" placeholder="Password">
    </div>
    <button type="submit" class="btn float-right" :class="'btn-dark'" @click.prevent="signup" :disabled="loading"><span v-if="loading">Creating your account...</span><span v-if="!loading">{{ signupText }}</span></button>
  </form>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'SignupBox',
  computed: {
    ...mapGetters(['isLoggedIn', 'isAnonymous', 'getUserData']),
  },
  props: ['signupText'],
  created() {
    this.googleProvider = new window.firebase.auth.GoogleAuthProvider();
  },
  methods: {
    isValidEmail(email) {
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    afterLogin(res) {
      const db = window.firebase.firestore();
      // const checkUsername = window.firebase.functions().httpsCallable('checkUsername');

      // checkUsername({ username: this.username }).then((res) => {
      //   this.usernameExists = res.data;
      // });
      const userDocRef = db.collection('users').doc(res.user.uid);
      const userDoc = {
        username: this.username,
      };
      userDocRef.set(userDoc)
        .then(this.$store.dispatch('setUserData', userDoc))
        .then(() => window.location.reload())
        .catch((err) => {
          console.log('err');
          console.log(err);
        });
    },
    // signupWithGoogle() {
    //   window.firebase.auth()
    //     .signInWithPopup(this.googleProvider)
    //     .then(res => this.afterLogin(res))
    //     .catch(err => this.$toasted.show(err.message));
    // },
    signup() {
      this.loading = true;
      if (this.isValidEmail(this.email)) {
        if (this.getCurrentUser && this.getCurrentUser.isAnonymous) {
          const cred = window.firebase.auth.EmailAuthProvider.credential(this.email, this.password);
          window.firebase.auth().currentUser.linkWithCredential(cred)
            .then(res => this.afterLogin(res))
            .catch(err => this.$toasted.show(err.message))
            .finally(() => {
              this.loading = false;
            });
        } else {
          window.firebase.auth()
            .createUserWithEmailAndPassword(this.email, this.password)
            .then(res => this.afterLogin(res))
            .catch(err => this.$toasted.show(err.message))
            .finally(() => {
              this.loading = false;
            });
        }
      }
    },
  },
  data() {
    return {
      loading: false,
      googleProvider: {},
      username: '',
      email: '',
      password: '',
    };
  },
};
</script>
